import React from 'react';

const Logout = () => (
    <div>
        You are logged out!
    </div>
);

export default Logout;